import { useContext } from "react";
import {
  Box,
  Divider,
  MenuItem,
  MenuList,
  Popover,
  Typography,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { AuthContext } from "../../../../../contexts/AuthContext";

interface AccountPopoverProps {
  anchorEl: null | HTMLElement;
  onClose?: () => void;
  open: boolean;
}

export const AccountPopover: React.FC<AccountPopoverProps> = ({
  anchorEl,
  onClose,
  open,
}) => {
  const { logout, userData } = useContext(AuthContext);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "left",
        vertical: "bottom",
      }}
      onClose={onClose}
      open={open}
    >
      <Box
        sx={{
          py: 1.5,
          px: 3,
          width: 200,
        }}
      >
        <Typography variant="overline">Account</Typography>
        <Typography color="text.secondary" variant="body2">
          {userData?.user?.firstName} {userData?.user?.lastName}
        </Typography>
      </Box>
      <Divider />
      <MenuList
        disablePadding
        dense
        sx={{
          p: 1,
          "& > *": {
            borderRadius: 1,
          },
        }}
      >
        <MenuItem onClick={() => logout()}>
          <ExitToAppIcon sx={{ marginRight: 1 }} />
          Logout
        </MenuItem>
      </MenuList>
    </Popover>
  );
};
